import { useMediaQuery } from '@mui/material';
import { useShallow } from 'zustand/react/shallow';

import { OSelect } from '@src/shared';
import { useMediaSettings } from '@src/hooks';
import { useMediaSettingsStore } from '@src/stores';

import { BsCameraVideo } from 'react-icons/bs';

const VideoSettings = () => {
  const isMobile = useMediaQuery('(max-width:768px)');

  const { videoInputDevices } = useMediaSettingsStore(
    useShallow((state) => ({
      videoInputDevices: state.mediaSettings.videoInputDevices,
    }))
  );

  const { selectedCamera, handleChangeMediaDevice } = useMediaSettings();

  return (
    <div className="settings-body-container">
      <OSelect
        items={videoInputDevices.map(({ deviceId, label }) => ({ value: deviceId, label }))}
        onChange={(id) => {
          const mediaDevice = videoInputDevices.find(({ deviceId }) => deviceId === id);
          mediaDevice && handleChangeMediaDevice(mediaDevice, 'video');
        }}
        classes={{
          selectContainer: 'settings-select',
        }}
        icon={<BsCameraVideo size={20} color="white" />}
        selectedValue={selectedCamera}
        label="Camera"
        alignItems="start"
        isDisabled={!videoInputDevices.length}
        tooltipContent={!videoInputDevices.length ? 'Allow camera access' : ''}
        size={isMobile ? 'medium' : 'large'}
      />
    </div>
  );
};

export default VideoSettings;
